import React, { Component } from 'react';

import { RANDOM_IMG } from '../../common/constants';
import { Container } from 'semantic-ui-react';

import img1 from '../../images/img1.jpg';

export default class ImgBanner extends Component {
  static propTypes = {

  };

  getSize(item){
    //if item is halfItem and the window is mobile 
    //take whole wiindow space otherwise take half
    const screenWidth = window.outerWidth
    // console.log("SIZE : " + screenWidth)
    // debugger;
    if(item.size == 'half' && screenWidth <= 768)//mobile 
    {
      return screenWidth ;
    }else if (item.size == 'half' && screenWidth > 768) {
      return (screenWidth / 2);
    }
    return screenWidth 
  }

  render() {
    return (
      <div className="common-img-banner"  style={{ width: this.getSize({size:'half'}) ,backgroundImage:`url(${RANDOM_IMG})` }}></div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/features/common/ImgBanner.js